import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './about-company.css'

const AboutCompany1 = (props) => {
  return (
    <div
      id={props.aboutId}
      className={`about-company1-container ${props.rootClassName} `}
    >
      <span
        id="aboutCompanyTitle"
        className="about-company1-about-company-title"
        >
        {props.aboutCompanyTitle ?? (
          <Fragment>
            <span className="about-company1-text10">
              What Stefan Lacher - Software Solutions stands for.
            </span>
          </Fragment>
        )}
      </span>
      <span className="about-company1-about-company-text">
        {props.aboutCompanyText ?? (
          <Fragment>
            <span className="about-company1-text11">
              <span>
                At Stefan Lacher - Software Solutions, I create modern,
                efficient, and sustainable software – tailored, modular, and
                easy to understand.
              </span>
              <br></br>
              <br></br>
              <span>
                I help individuals and businesses solve complex technical
                challenges by combining in-depth expertise in data, systems, and
                processes with a strong focus on quality and user experience.
              </span>
              <br></br>
              <br></br>
              <span>
                My mission is not just to build software but to deliver
                intelligent solutions that simplify everyday life, optimize
                processes, and create long-lasting value.
              </span>
              <br></br>
              <br></br>
              <span>My principles:</span>
              <br></br>
              <span>→ </span>
              <span>
                Clear communication – making technology understandable
              </span>
              <br></br>
              <span>→ </span>
              <span>
                Efficient implementation – using modern technologies where they
                add real value
              </span>
              <br></br>
              <span>→ </span>
              <span>
                Tailored solutions – no one-size-fits-all approach, but
                architecture that fits your needs
              </span>
              <br></br>
              <span>→ </span>
              <span>
                Sustainability – building systems that are scalable and
                maintainable over time
              </span>
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

AboutCompany1.defaultProps = {
  aboutId: 'AboutCompany',
  rootClassName: '',
  aboutCompanyTitle: undefined,
  aboutCompanyText: undefined,
}

AboutCompany1.propTypes = {
  aboutId: PropTypes.string,
  rootClassName: PropTypes.string,
  aboutCompanyTitle: PropTypes.element,
  aboutCompanyText: PropTypes.element,
}

export default AboutCompany1
